import api from "./api"

export const getDeposits = async () => {
  const response = await api.get("/deposits")
  return response.data
}

export const getDepositById = async (depositId) => {
  const response = await api.get(`/deposits/${depositId}`)
  return response.data
}

export const getDepositFormData = async () => {
  const response = await api.get("/deposits/form-data")
  return response.data
}

export const createDeposit = async (payload) => {
  const response = await api.post("/deposits", payload)
  return response.data
}

export const updateDeposit = async (depositId, payload) => {
  const response = await api.put(`/deposits/${depositId}`, payload)
  return response.data
}

export const deleteDeposit = async (depositId) => {
  const response = await api.delete(`/deposits/${depositId}`)
  return response.data
}